import { LicenseManager } from "ag-grid-enterprise";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/all.min.css";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, useNavigate } from "react-router-dom";
import { VsiAppProvider } from "./stores/VsiApp";
import { DevSupport } from "@react-buddy/ide-toolbox";
import { ComponentPreviews, useInitial } from "./dev";
import { Auth0Provider } from "@auth0/auth0-react";
import { auth0Client } from "./utils/utils";
import { AlertProvider } from "./stores/Alerts";

const root = ReactDOM.createRoot(document.getElementById("root"));

LicenseManager.setLicenseKey(
  "Using_this_{AG_Grid}_Enterprise_key_{AG-070860}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Clear_Technologies}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Visual_Storage_Intelligence}_only_for_{3}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{Visual_Storage_Intelligence}_need_to_be_licensed___{Visual_Storage_Intelligence}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{4_January_2026}____[v3]_[01]_MTc2NzQ4NDgwMDAwMA==f22121ee4b0a830beba5bde07772a6af"
);

const Auth0ProviderWithRedirectCallback = ({ children, ...props }) => {
  const navigate = useNavigate();
  const onRedirectCallback = (appState) => {
    navigate((appState && appState.returnTo) || window.location.pathname);
  };
  return (
    <Auth0Provider
      domain="visualstorageintelligence.auth0.com"
      clientId={auth0Client}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: "https://visual1intelligence.com/api/v6/",
      }}
      cacheLocation="localstorage" // Persist tokens in local storage
      useRefreshTokens // Enable refresh tokens to keep users logged in
      useRefreshTokensFallback // Fallback to silent auth if refresh tokens fail
      onRedirectCallback={onRedirectCallback} {...props}>
      {children}
    </Auth0Provider>
  );
};

root.render(
   //<React.StrictMode>
  <BrowserRouter>
    <DevSupport
      ComponentPreviews={ComponentPreviews}
      useInitialHook={useInitial}
    >
      <Auth0ProviderWithRedirectCallback>
          <AlertProvider/>
          <VsiAppProvider>
            <App />
          </VsiAppProvider>
      </Auth0ProviderWithRedirectCallback>
    </DevSupport>
  </BrowserRouter>
   //</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
